jQuery(document).ready(function(){	
	
	jQuery('.carousel-slider').slick({
		centerMode: true,
	  	centerPadding: '400px',
	  	slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		dots: true,
		autoplay: true,
		autoplaySpeed: 2000,
		prevArrow:'<button type="button" class="slick-prev"><i class="las la-arrow-alt-circle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="las la-arrow-alt-circle-right"></i></button>',
		responsive: [
			{
			  breakpoint: 720,
			  settings: {
		      	centerMode: false,
		      	//adaptiveHeight: true
			  }
			}
		]			
	});
	
	jQuery('.gallery-slider').slick({
	  	slidesToShow: 4,
		infinite: true,
		slidesToScroll: 1,
		dots: false,
		autoplay: false,
		prevArrow:'<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',
		responsive: [
			{
			  breakpoint: 720,
			  settings: {
		      	centerMode: false,
		      	//adaptiveHeight: true
			  }
			}
		]			
	});
	
	jQuery('.hero-slider').slick({
	  	slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		dots: true,
		autoplay: false,
		arrows: false,
		adaptiveHeight: false,
		fade: true,
		cssEase: 'linear'		
	});
	
});